/**
 * Labstep
 *
 * @module components/ProtocolDevice/List
 * @desc ProtocolDevice list
 */

import { EntityDraggable } from 'labstep-web/components/Entity/Draggable';
import { ProtocolDeviceListItem } from 'labstep-web/components/ProtocolDevice/ListItem';
import { List } from 'labstep-web/core/List';
import { ProtocolDevice } from 'labstep-web/models/protocol-device.model';
import type React from 'react';
import type { IProtocolDeviceListProps } from './types';

export const ProtocolDeviceList: React.FC<
  IProtocolDeviceListProps
> = ({ protocolDevices }) => (
  <List id="protocol-device-list">
    {protocolDevices.map((protocolDevice: ProtocolDevice) => (
      <EntityDraggable
        key={protocolDevice.id}
        entityGuid={protocolDevice.id}
        entityName={ProtocolDevice.entityName}
        isReference
      >
        <ProtocolDeviceListItem protocolDevice={protocolDevice} />
      </EntityDraggable>
    ))}
  </List>
);
